module.exports = __webpack_public_path__ + "img/dx.58e85665.webp";